document.addEventListener('variant:changed', function (event) {
  const variant = event.detail.variant;
  const isDiscontinued = (window.__PRODUCT_TAGS__ || []).includes("discontinued");
  const isMadeToOrder = (window.__PRODUCT_TAGS__ || []).includes("availability-MTO");
  const productInventoryElement = document.querySelector(".product-item__inventory");
  if (!productInventoryElement) return;
  const isAvailableEl = document.getElementById("availability_slow");
  const isSlow = isAvailableEl?.dataset?.availability === "true";
  document.querySelectorAll(".discontinued-badge").forEach(el => el.remove());
  productInventoryElement.classList.remove("inventory--high", "inventory--low");
  productInventoryElement.removeAttribute("id");
  productInventoryElement.style.marginBottom = "";
  productInventoryElement.style.color = "";
  productInventoryElement.innerHTML = "";
  if (isDiscontinued) {
    const discontinuedBadge = document.createElement("div");
    discontinuedBadge.className = "discontinued-badge";
    discontinuedBadge.innerText = "Discontinued";
    discontinuedBadge.style.background = "#b00020";
    discontinuedBadge.style.color = "#fff";
    discontinuedBadge.style.padding = "4px 8px";
    discontinuedBadge.style.fontSize = "12px";
    discontinuedBadge.style.borderRadius = "4px";
    discontinuedBadge.style.marginBottom = "10px";
    productInventoryElement.before(discontinuedBadge);
    productInventoryElement.style.color = "rgb(120,120,120)";
    productInventoryElement.innerHTML = `Contact us for further information.`;
    return;
  }
  if (variant?.available) {
    if (isMadeToOrder) {
      productInventoryElement.classList.add("inventory--high");
      productInventoryElement.id = "available-orange";
      productInventoryElement.style.color = "#29615E";
      productInventoryElement.style.marginBottom = "14px";
      productInventoryElement.innerHTML = `Made to Order <div class="tooltip" id="inventory-tooltip"><span class="info-hover">i</span><span class="tooltiptext">Manufacturing of this product begins after your order has been paid. Standard lead times of 2-5 days apply. Contact us if your order is urgent.</span></div>`;
    } else if (isSlow) {
      productInventoryElement.classList.add("inventory--high");
      productInventoryElement.id = "available-orange";
      productInventoryElement.style.color = "#ff9307";
      productInventoryElement.style.marginBottom = "14px";
      productInventoryElement.innerHTML = `Subject to lead times <div class="tooltip" id="inventory-tooltip"><span class="info-hover">i</span><span class="tooltiptext">Contact us for further information.</span></div>`;
    } else {
      productInventoryElement.classList.add("inventory--high");
      productInventoryElement.id = "available-green";
      productInventoryElement.style.color = "#008a00";
      productInventoryElement.innerHTML = `In stock`;
    }
  } else {
    productInventoryElement.id = "inventory-soldout";
    productInventoryElement.style.marginBottom = "15px";
    productInventoryElement.style.color = "#000";
    productInventoryElement.innerHTML = `Sold out <div class="tooltip"><span class="info-hover">i</span><span class="tooltiptext">Please contact us for alternative product suggestions and further information on the expected restock date.</span></div>`;
  }
});

/* NND SMART BONDS SEARCH v1 */
(function () {
  var smartPicks = null;
  function uniqueCandidates(root, role) {
    var seen = {};
    return Array.prototype.filter.call(root.querySelectorAll('[data-nnd-smart-product][data-nnd-role="' + role + '"]'), function (element) {
      var id = element.getAttribute('data-nnd-product-id');
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }
  function shuffled(items) {
    var copy = items.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i]; copy[i] = copy[j]; copy[j] = temp;
    }
    return copy;
  }
  function choose(root, role, count) {
    var candidates = uniqueCandidates(root, role);
    var previousIds = (smartPicks && smartPicks[role]) || [];
    var chosen = [];
    previousIds.forEach(function (id) {
      var match = candidates.find(function (candidate) { return candidate.getAttribute('data-nnd-product-id') === id; });
      if (match && chosen.length < count) chosen.push(match);
    });
    shuffled(candidates).forEach(function (candidate) {
      if (chosen.length >= count) return;
      var id = candidate.getAttribute('data-nnd-product-id');
      var alreadyChosen = chosen.some(function (selected) { return selected.getAttribute('data-nnd-product-id') === id; });
      if (!alreadyChosen) chosen.push(candidate);
    });
    candidates.forEach(function (candidate) { candidate.hidden = true; });
    chosen.forEach(function (candidate) { candidate.hidden = false; });
    smartPicks[role] = chosen.map(function (candidate) { return candidate.getAttribute('data-nnd-product-id'); });
  }
  function applySmartSearch(root) {
    if (!smartPicks) smartPicks = {'dacks-men': [], 'dacks-women': [], 'bonds': []};
    choose(root, 'dacks-men', 1); choose(root, 'dacks-women', 1); choose(root, 'bonds', 2);
    root.setAttribute('data-nnd-smart-ready', 'true');
  }
  function scanSmartSearch() {
    var roots = document.querySelectorAll('[data-nnd-bonds-merchandising], [data-nnd-brand-merchandising], [data-nnd-category-dacks-merchandising]');
    if (!roots.length) { smartPicks = null; return; }
    Array.prototype.forEach.call(roots, applySmartSearch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scanSmartSearch); else scanSmartSearch();
  new MutationObserver(scanSmartSearch).observe(document.documentElement, {childList: true, subtree: true});
})();

/* NND BONDS TO DACKS SOLD OUT REDIRECT v1 */
(function () {
  function syncDacksRedirect(container, variant) {
    if (!container) return;
    var primaryCta = container.querySelector('[data-nnd-primary-cta]');
    var redirectCta = container.querySelector('[data-nnd-dacks-redirect]');
    if (!primaryCta || !redirectCta) return;
    var unavailable = variant ? variant.available === false : container.getAttribute('data-nnd-selected-available') === 'false';
    if (unavailable) { primaryCta.style.display = 'none'; redirectCta.hidden = false; redirectCta.style.display = ''; }
    else { primaryCta.style.display = ''; redirectCta.hidden = true; redirectCta.style.display = 'none'; }
  }
  function syncAllDacksRedirects(variant) {
    document.querySelectorAll('.product-form__payment-container[data-nnd-dacks-target]').forEach(function (container) { syncDacksRedirect(container, variant); });
  }
  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    window.setTimeout(function () { syncAllDacksRedirects(variant); }, 0);
  });
  function initialiseDacksRedirects() { syncAllDacksRedirects(null); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseDacksRedirects); else initialiseDacksRedirects();
})();

/* DACKS GWP DISPLAY FIX - 15 OCT 2026 */
(function () {
  function hideZeroValueDacksGwpLabels() {
    if (!window.theme || window.theme.pageType !== 'cart') return;
    var labels = document.querySelectorAll('.line-item__discount');
    Array.prototype.forEach.call(labels, function (label) {
      var text = (label.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      var isDacksGwp = text.indexOf('dacks gift with purchase free washbag valued @ $15') !== -1;
      var isZeroAllocation = text.indexOf('(-$0.00)') !== -1 || text.indexOf('(-$0)') !== -1;
      if (isDacksGwp && isZeroAllocation) label.remove();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideZeroValueDacksGwpLabels); else hideZeroValueDacksGwpLabels();
  new MutationObserver(hideZeroValueDacksGwpLabels).observe(document.documentElement, {childList: true, subtree: true});
})();

/* NDIS / HOME CARE HOMEPAGE BANNER FIX - 16 OCT 2026
 * The global RTE image lightbox listens on BODY in capture phase. Intercept
 * mousedown one level earlier at DOCUMENT for these two linked banners only,
 * allowing the normal anchor click to continue without opening the lightbox.
 */
(function () {
  function isFundingBanner(img) {
    if (!img || img.tagName !== 'IMG') return false;
    var src = img.getAttribute('src') || '';
    return src.indexOf('ndis-7.jpg') !== -1 || src.indexOf('care-12.jpg') !== -1;
  }

  document.addEventListener('mousedown', function (event) {
    var img = event.target && event.target.closest ? event.target.closest('img') : null;
    if (isFundingBanner(img) && img.closest('a')) {
      event.stopPropagation();
    }
  }, true);

  function routeFundingBanners() {
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;

    var ndisImage = document.querySelector('img[src*="ndis-7.jpg"]');
    if (ndisImage) {
      var ndisLink = ndisImage.closest('a');
      if (ndisLink) {
        ndisLink.setAttribute('href', '/pages/ndis-funding-solutions#ndis-start-here');
        ndisLink.removeAttribute('target');
        ndisLink.setAttribute('aria-label', 'Explore NDIS Funding Solutions');
      }
    }

    var homeCareImage = document.querySelector('img[src*="care-12.jpg"]');
    if (homeCareImage) {
      var homeCareLink = homeCareImage.closest('a');
      if (homeCareLink) {
        homeCareLink.setAttribute('href', '/pages/ndis-funding-solutions#ndis-support');
        homeCareLink.removeAttribute('target');
        homeCareLink.setAttribute('aria-label', 'Explore Home Care Package funding information');
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', routeFundingBanners); else routeFundingBanners();
  new MutationObserver(routeFundingBanners).observe(document.documentElement, {childList: true, subtree: true});
})();
